import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from '../../authentication/authentication.service';
import { environment } from '../../../../environments/environment';
import { ToastrService } from '../../toast/toastr.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    private auth:AuthenticationService,
    private toastr: ToastrService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // 🚨 Block all requests if deployment flag is on
    if (environment.undergoing_deployment) {
      this.toastr.show({
        title: '🚨 Service Unavailable',
        message: 'We are currently undergoing maintenance/deployment. Please try again later.',
        disableTimeout: true,
        type: 'WARNING'
      });

      return throwError(() => new HttpErrorResponse({
        status: 503, statusText: 'Service Unavailable', url: request.url
      }));
    }

    const headers = {} as any;
    
    if (this.auth.isLoggedIn) {
      headers["Authorization"] = `Bearer ${this.auth.user?.token}`;
    }

    return next.handle(request.clone({
      setHeaders: headers
    }));
  }
}
